<!--
 * @Description  : 移动CA服务费权益
 * @Author       : git config user.sname
 * @Date         : 2025-12-26 14:45:15
 * @LastEditors  : git config user.sname
 * @LastEditTime : 2025-12-29 11:35:58
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\commodity-management\product-list\components\CaRights.vue
-->
<template>
	<div>
		<el-form
			class="tableForm"
			size="medium"
			ref="rightsObjRfe"
			label-width="110px"
			:model="rightsObj"
			:show-message="false"
			:disabled="isDiabled"
		>
			<el-form-item label="基础绑定数" prop="baseBind" :rules="requiredRule" label-width="110px">
				<el-input placeholder="请输入" v-model="rightsObj.baseBind" @input="moneyCheck($event, 'rightsObj', 'baseBind')" :maxlength="10">
					<template slot="append">个</template>
				</el-input>
			</el-form-item>
			<el-form-item label="赠送商品" prop="goods">
				<el-select v-model="rightsObj.goods" multiple size="small" @change="changeSelect">
					<el-option v-for="item in goodOptions" :key="item.id" :label="item.sname" :value="item.id"> </el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="赠送商品数" prop="goods" v-if="rightsObj.goods.length != 0">
				<div v-for="(item, index) in rightsObj.giveGoodList" :key="'赠送商品数' + index" class="goods-list">
					<span class="list-title">{{ item.giveName }}</span>
					<el-input
						placeholder="请输入"
						v-model="item.giveNum"
						@input="moneyCheck($event, 'rightsObj', 'giveGoodList', 'giveNum', index)"
						:maxlength="10"
					>
						<template slot="append">个</template>
					</el-input>
				</div>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
import { mapState } from "vuex";

import * as Api from "@/api/modules/commodity-management";

export default {
	data() {
		return {
			isDiabled: false, //禁止编辑
			rightsObj: {
				baseBind: '',
				goods: [],
				giveGoodList: []
			},
			goodOptions: [],
			requiredRule: [{ required: true, message: '', trigger: ['change', 'blur'] }]
		}
	},
	created() {
		this.getList()
	},
	methods: {
		initData(data,type) {
			console.log('8888888888888888888888-0000')
			this.rightsObj.baseBind = 1
			this.rightsObj.giveGoodList = []
			if (data) {
				Object.keys(this.rightsObj).forEach((key) => {
					this.rightsObj[key] = data[key]
				})
				let ids = data.giveGoodList.map(item => item.giveId)
				this.rightsObj.goods= ids
				// this.rightsObj.giveGoodList = ids
				console.log(data)
				this.isDiabled = type == 'view' ? true : false
			}
		},
		//获取商品
		getList() {
			let params = {
				current: 1,
				size: -1
			}
			Api.getGoodPage(params)
				.then((res) => {
					this.goodOptions = res.data.records
				})
				.catch((err) => {
					this.goodOptions = []
				})
		},
		//商品权益信息输入处理
		moneyCheck(value, bindForm, bindKey, form, index) {
			value = value.replace(/^0|[^0-9]/g, '')

			if (bindKey == 'giveGoodList') {
				this.$set(this[bindForm].giveGoodList[index], form, value)
			} else {
				this.$set(this[bindForm], bindKey, value)
			}

			return value
		},
		//赠送商品处理
		changeSelect(value) {
			let arr = []
			let newArr = [].concat(this.goodOptions)
			if (value && value.length != 0) {
				newArr.map((x) => {
					value.map((y) => {
						if (x.id == y) {
							let obj = {
								giveName: x.sname,
								giveId: x.id,
								giveNum: ''
							}
							arr.push(obj)
						}
					})
				})
			}

			this.rightsObj.giveGoodList = arr
		}
	},
	computed: {
		...mapState('dict', {
			commodityDict: (state) => state.commodityDict //商品字典
		})
	}
}
</script>
<style lang="less" scoped>
.goods-list {
	width: 100%;
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	display: flex;
	justify-content: space-between;
	margin-bottom: 10px;
	.list-title {
		padding-left: 10px;
	}
	/deep/.el-input-group {
		width: 200px;
	}
	/deep/.el-input__inner,
	/deep/.el-input-group__append {
		border-radius: 0;
	}
}
</style>
